import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { PortfolioProjectModel } from '@smarttask-common/src/lib/models/Portfolio/Project/PortfolioProjectModel';

export enum PortfolioProjectActionTypes {
    ADD_PORTFOLIO_PROJECT = '[PortfolioProject] Create PortfolioProject',
    ADD_PORTFOLIO_PROJECTS = '[PortfolioProject] Add PortfolioProjects',
    UPSERT_PORTFOLIO_PROJECT = '[PortfolioProject] Upsert PortfolioProject',
    UPSERT_PORTFOLIO_PROJECTS = '[PortfolioProject] Upsert PortfolioProjects',
    UPDATE_PORTFOLIO_PROJECT = '[PortfolioProject] Update PortfolioProject',
    UPDATE_PORTFOLIO_PROJECTS = '[PortfolioProject] Update PortfolioProjects',
    DELETE_PORTFOLIO_PROJECT = '[PortfolioProject] Delete PortfolioProject',
    DELETE_PORTFOLIO_PROJECTS = '[PortfolioProject] Delete PortfolioProjects',
    DELETE_ALL_PORTFOLIO_PROJECTS = '[PortfolioProject] Delete All PortfolioProjects',
    DELETE_ALL = '[PortfolioProject] Delete All',

    UPDATE_SELECTED_ID = '[PortfolioProject] Update SelectedId',
}

export class UpdateSelectedProjectId implements Action {
    readonly type = PortfolioProjectActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_project_id: string) {}
}

export class AddOne implements Action {
    readonly type = PortfolioProjectActionTypes.ADD_PORTFOLIO_PROJECT;
    constructor(public portfolio_project: PortfolioProjectModel) {}
}

export class AddMany implements Action {
    readonly type = PortfolioProjectActionTypes.ADD_PORTFOLIO_PROJECTS;
    constructor(public portfolio_projects: Array<PortfolioProjectModel>) {}
}

export class UpsertOne implements Action {
    readonly type = PortfolioProjectActionTypes.UPSERT_PORTFOLIO_PROJECT;

    constructor(public portfolio_project: PortfolioProjectModel) {}
}

export class UpsertMany implements Action {
    readonly type = PortfolioProjectActionTypes.UPSERT_PORTFOLIO_PROJECTS;
    constructor(public portfolio_projects: Array<PortfolioProjectModel>) {}
}

export class UpdateOne implements Action {
    readonly type = PortfolioProjectActionTypes.UPDATE_PORTFOLIO_PROJECT;
    constructor(public portfolio_project: Update<PortfolioProjectModel>) {}
}

export class UpdateMany implements Action {
    readonly type = PortfolioProjectActionTypes.UPDATE_PORTFOLIO_PROJECTS;
    constructor(public portfolio_projects: Array<Update<PortfolioProjectModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = PortfolioProjectActionTypes.DELETE_PORTFOLIO_PROJECT;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = PortfolioProjectActionTypes.DELETE_PORTFOLIO_PROJECTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = PortfolioProjectActionTypes.DELETE_ALL_PORTFOLIO_PROJECTS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = PortfolioProjectActionTypes.DELETE_ALL;
    constructor() {}
}

export type PortfolioProjectActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedProjectId;
